@if (allowedSendTypes().length === 1) {
  <button
    bitButton
    [buttonType]="hideIcon && btnTextAddCreateFeatureFlag() ? 'secondary' : 'primary'"
    type="button"
    [startIcon]="!hideIcon ? 'bwi-plus' : null"
    (click)="onRestrictedClick()"
  >
    {{ title | i18n }}
  </button>
} @else {
  <button
    bitButton
    [bitMenuTriggerFor]="itemOptions"
    [buttonType]="hideIcon && btnTextAddCreateFeatureFlag() ? 'secondary' : 'primary'"
    type="button"
    [startIcon]="!hideIcon ? 'bwi-plus' : null"
  >
    {{ title | i18n }}
  </button>
  <bit-menu #itemOptions>
    <button type="button" bitMenuItem (click)="createSend(sendType.Text)">
      <bit-icon name="bwi-file-text" slot="start"></bit-icon>
      {{ "sendTypeText" | i18n }}
    </button>
    <button type="button" bitMenuItem (click)="createSend(sendType.File)">
      <bit-icon name="bwi-file" slot="start"></bit-icon>
      <div class="tw-flex tw-items-center tw-gap-2">
        {{ "sendTypeFile" | i18n }}
        <app-premium-badge></app-premium-badge>
      </div>
    </button>
  </bit-menu>
}
